define('home/models/TopicFeed',[
    'home/collections/FeedItemCollection',

    'core/UniqueModel',
    'home/models/Feed',
], function (
    FeedItemCollection,

    UniqueModel,
    Feed
) {
    'use strict';

    var TopicFeed = Feed.extend({
        initialize: function () {
            Feed.prototype.initialize.call(this, {}, {
                collectionClass: FeedItemCollection,
                collectionOptions: {
                    type: 'profile',
                    target: 'topic:' + this.id,
                },
            });
        },

        shouldFetch: function () {
            return !this.get('items').length;
        },

        fetch: function (options) {
            if (!this.get('items').length)
                this.fetchItems(options);
        },

        parse: function (response) {
            return response.response;
        },
    });

    UniqueModel.addType('TopicFeed', TopicFeed);

    return TopicFeed;
});

